const verifyParameter = (appData, propertyName, message="") => {
    if (!propertyName in appData) {
        console.log(`Missing parameter - ${propertyName}`)
    }
}

const getProgramAssessmentId = (appData) => {
    verifyParameter(appData, 'programId')
    const programId = appData['programId']
    verifyParameter(appData, 'assessment')
    const assessment = appData['assessment']

    let programAssessmentArray = assessment.programAssessments
    for (let i = 0; i < programAssessmentArray.length; i++) {
        if (programAssessmentArray[i].programId == programId) {
            return programAssessmentArray[i].assessmentId
        }
    }
}

const getCachedProgramAssessment = (appData) => {
    verifyParameter(appData, 'programId')
    const programId = appData['programId']
    verifyParameter(appData, 'assessment')
    const assessment = appData['assessment']

    let programAssessmentArray = assessment.programAssessments
    for (let i = 0; i < programAssessmentArray.length; i++) {
        if (programAssessmentArray[i].programId == programId) {
            return programAssessmentArray[i]
        }
    }
}

const getStep1Id = (appData) => {
    let programAssessment = getCachedProgramAssessment(appData)
    if (programAssessment.step1Data) {
        return programAssessment.step1Data.step1Id
    }
}

const getStep1SloDataId = (appData) => {
    verifyParameter(appData, 'sloId')
    const sloId = appData['sloId']

    let programAssessment = getCachedProgramAssessment(appData)
    if (programAssessment.step1Data) {
        if (programAssessment.step1Data.step1Id) {
            let tmp_step1Data = programAssessment.step1Data
            for (let i = 0; i < tmp_step1Data.learningOutcomes.length; i++) {
                let tmp_sloData = tmp_step1Data.learningOutcomes[i]
                if (tmp_sloData.step1sloDataId &&
                        tmp_sloData.sloId == sloId) {
                    return tmp_sloData.step1sloDataId
                }
            }
        }
    }
}

const formatStep1Data = (appData) => {
    verifyParameter(appData, 'step1DataStore')
    const step1DataStore = appData['step1DataStore']
    verifyParameter(appData, 'step1CompletionData')
    const step1CompletionData = appData['step1CompletionData']
    verifyParameter(appData, 'currentUser')
    const currentUser = appData['currentUser']
    verifyParameter(appData, 'dateTime')
    const dateTime = appData['dateTime']
    verifyParameter(appData, 'programAssessmentId')
    const programAssessmentId = appData['programAssessmentId']
    verifyParameter(appData, 'programId')
    const programId = appData['programId']
    verifyParameter(appData, 'learningOutcomes')
    const learningOutcomes = appData['learningOutcomes']

    let step1Data = step1DataStore[programId]
    let result = null
    if (step1Data) {
        let s1Data = {
            createdBy: step1CompletionData[programId].createdBy,
            dateCreated: step1CompletionData[programId].dateCreated,
            modifiedBy: currentUser,
            dateModified: dateTime.toISOString()
        }
        
        // Here we need to determine whether we need an ID (exists)
        // or skip the ID (new)
        if (programAssessmentId) {
            // We only get the Step1 ID if Step1 was previously saved.
            let step1Id = getStep1Id({
                programId: appData.programId,
                assessment: appData.assessment,
            })
            if (step1Id) {
                s1Data["step1Id"] = step1Id
            }
        }
        
        if (step1CompletionData[programId]?.completed) {
            s1Data["completed"] = step1CompletionData[programId].completed
            s1Data["dateCompleted"] = step1CompletionData[programId].dateCompleted
            s1Data["completedBy"] = step1CompletionData[programId].completedBy
        } else {
            s1Data["completed"] = false
            s1Data["dateCompleted"] = ""
            s1Data["completedBy"] = ""
        }

        let s1SloData = []
        learningOutcomes[programId].map(slo => {
            if (slo.sloId in step1Data) {
                let tmpSloData = {
                    sloId: slo.sloId,
                    focusQuestion: step1Data[slo.sloId].s1q1,
                }

                if (programAssessmentId) {
                    let stepSloId = getStep1SloDataId({
                        programId: programId,
                        sloId: slo.sloId,
                        assessment: appData.assessment,                      
                    })
                    if (stepSloId) {
                        tmpSloData["step1sloDataId"] = stepSloId
                    }
                }

                s1SloData.push(tmpSloData)
            }
        })
        if (s1SloData.length > 0) {
            s1Data["learningOutcomes"] = s1SloData
        }
        
        result = s1Data
    } // --end step 1
    return result
}

const getStep2Id = (appData) => {
    let programAssessment = getCachedProgramAssessment(appData)
    if (programAssessment.step2Data) {
        return programAssessment.step2Data.step2Id
    }
}

const getStep2SloDataId = (appData) => {
    const sloId = appData['sloId']

    let programAssessment = getCachedProgramAssessment(appData)
    // Does the Program Assessment have Step 2 Data?
    if (programAssessment.step2Data) {
        // Check if the Step 2 data has an ID
        if (programAssessment.step2Data.step2Id) {
            let tmp_step2Data = programAssessment.step2Data
            for (let i = 0; i < tmp_step2Data.learningOutcomes.length; i++) {
                let tmp_sloData = tmp_step2Data.learningOutcomes[i]
                if (tmp_sloData.step2sloDataId &&
                        tmp_sloData.sloId == sloId) {
                    return tmp_sloData.step2sloDataId
                }
            }
        }
    }
}

const formatStep2Data = (appData) => {
    let dateTime = appData['dateTime']
    let programAssessmentId = appData['programAssessmentId']
    let programId = appData['programId']
    let learningOutcomes = appData['learningOutcomes']
    let step2DataStore = appData['step2DataStore']
    let step2CompletionData = appData['step2CompletionData']
    let currentUser = appData['currentUser']

    let step2Data = step2DataStore[programId]
    let result = null
    if (step2Data) {
        let s2Data = {
            createdBy: step2CompletionData[programId].createdBy,
            dateCreated: step2CompletionData[programId].dateCreated,
            modifiedBy: currentUser,
            dateModified: dateTime.toISOString()
        }

        // Here we need to determine whether we need an ID (exists)
        // or skip the ID (new)
        if (programAssessmentId) {
            let step2Id = getStep2Id({
                programId: appData.programId,
                assessment: appData.assessment,
            })
            if (step2Id) {
                s2Data["step2Id"] = step2Id
            }
        }

        if (step2CompletionData[programId]?.completed) {
            s2Data["completed"] = step2CompletionData[programId].completed
            s2Data["dateCompleted"] = step2CompletionData[programId].dateCompleted
            s2Data["completedBy"] = step2CompletionData[programId].completedBy
        } else {
            s2Data["completed"] = false
            s2Data["dateCompleted"] = ""
            s2Data["completedBy"] = ""
        }
        let s2SloData = []
        learningOutcomes[programId].map(slo=> {
            if (slo.sloId in step2Data) {
                let tmpSloData = {
                    sloId: slo.sloId,
                    toolDescription: step2Data[slo.sloId].toolDescription,
                    coursesAssessed: step2Data[slo.sloId].coursesAssessed,
                    brightspaceAutomation: step2Data[slo.sloId].brightspaceAutomation,
                    hypotheticalAnalysis: step2Data[slo.sloId].hypotheticalAnalysis
                }

                if (programAssessmentId) {
                    let stepSloId = getStep2SloDataId({
                        programId: programId, 
                        sloId: slo.sloId,
                        assessment: appData.assessment,
                    })
                    if (stepSloId) {
                        tmpSloData["step2sloDataId"] = stepSloId
                    }
                }

                s2SloData.push(tmpSloData)
            }
        })
        if (s2SloData.length > 0) {
            s2Data["learningOutcomes"] = s2SloData
        }
        result = s2Data
    } // --end step 2
    return result
}

const getStep3Id = (appData) => {
    let programAssessment = getCachedProgramAssessment(appData)
    if (programAssessment.step3Data) {
        return programAssessment.step3Data.step3Id
    }
}

const formatStep3Data = (appData) => {
    let dateTime = appData['dateTime']
    verifyParameter(appData, 'dateTime')
    let programAssessmentId = appData['programAssessmentId']
    verifyParameter(appData, 'programAssessmentId')
    let programId = appData['programId']
    verifyParameter(appData, 'programId')
    let step3DataStore = appData['step3DataStore']
    verifyParameter(appData, 'step3DataStore')
    let step3CompletionData = appData['step3CompletionData']
    verifyParameter(appData, 'step3CompletionData')
    let currentUser = appData['currentUser']
    verifyParameter(appData, 'currentUser')

    let step3Data = step3DataStore[programId]
    let result = null
    if (step3Data) {
        let s3Data = {
            assessmentToolUsed: step3Data.s3q1,
            createdBy: step3CompletionData[programId].createdBy,
            dateCreated: step3CompletionData[programId].dateCreated,
            modifiedBy: currentUser,
            dateModified: dateTime.toISOString()
        }

        if (step3CompletionData[programId]?.completed) {
            s3Data["completed"] = step3CompletionData[programId].completed
            s3Data["dateCompleted"] = step3CompletionData[programId].dateCompleted
            s3Data["completedBy"] = step3CompletionData[programId].completedBy
        } else {
            s3Data["completed"] = false
            s3Data["dateCompleted"] = ""
            s3Data["completedBy"] = ""
        }

        // Here we need to determine whether we need an ID (exists)
        // or skip the ID (new)
        if (programAssessmentId) {
            let step3Id = getStep3Id({
                programId: programId,
                assessment: appData.assessment,
            })
            if (step3Id) {
                s3Data["step3Id"] = step3Id
            }
        }

        result = s3Data
    } // --end step 3
    return result
}

const getStep4Id = (appData) => {
    let programAssessment = getCachedProgramAssessment(appData)
    if (programAssessment.step4Data) {
        return programAssessment.step4Data.step4Id
    }
}

const getStep4SloDataId = (appData) => {
    const sloId = appData['sloId']
    let programAssessment = getCachedProgramAssessment(appData)
    if (programAssessment.step4Data) {
        if (programAssessment.step4Data.step4Id) {
            let tmp_step4Data = programAssessment.step4Data
            for (let i = 0; i < tmp_step4Data.learningOutcomes.length; i++) {
                let tmp_sloData = tmp_step4Data.learningOutcomes[i]
                if (tmp_sloData.step4sloDataId &&
                        tmp_sloData.sloId == sloId) {
                    return tmp_sloData.step4sloDataId
                }
            }
        }
    }
}

const formatStep4Data = (appData) => {
    let dateTime = appData['dateTime']
    verifyParameter(appData, 'dateTime')
    let programAssessmentId = appData['programAssessmentId']
    verifyParameter(appData, 'programAssessmentId')
    let programId = appData['programId']
    verifyParameter(appData, 'dateTime')
    let learningOutcomes = appData['learningOutcomes']
    verifyParameter(appData, 'dateTime')
    let step4DataStore = appData['step4DataStore']
    verifyParameter(appData, 'step4DataStore')
    let step4CompletionData = appData['step4CompletionData']
    verifyParameter(appData, 'step4CompletionData')
    let currentUser = appData['currentUser']
    verifyParameter(appData, 'currentUser')

    let step4Data = step4DataStore[programId]
    if (step4Data) {
        let s4Data = {
            createdBy: step4CompletionData[programId].createdBy,
            dateCreated: step4CompletionData[programId].dateCreated,
            modifiedBy: currentUser,
            dateModified: dateTime.toISOString()
        }
        //////////////////////////////////////
        // Here we need to determine whether we need an ID (exists)
        // or skip the ID (new)
        if (programAssessmentId) {
            let step4Id = getStep4Id({
                programId: programId,
                assessment: appData.assessment,
            })
            if (step4Id) {
                s4Data["step4Id"] = step4Id
            }
        }

        if (step4CompletionData[programId]?.completed) {
            s4Data["completed"] = step4CompletionData[programId].completed
            s4Data["dateCompleted"] = step4CompletionData[programId].dateCompleted
            s4Data["completedBy"] = step4CompletionData[programId].completedBy
        } else {
            s4Data["completed"] = false
            s4Data["dateCompleted"] = ""
            s4Data["completedBy"] = ""
        }
        let s4SloData = []
        learningOutcomes[programId].map(slo=> {
            if (slo.sloId in step4Data) {
                let tmpSloData = {
                    sloId: slo.sloId,
                    resultsSummary: step4Data[slo.sloId].summaryOfResults,
                    focusAreaReflection: step4Data[slo.sloId].reflectionOnHypothesis,
                    interpretationOfResults: step4Data[slo.sloId].interpretationOfResults,
                    followUpQuestions: step4Data[slo.sloId].followUpQuestions,
                    actionsForImprovement: step4Data[slo.sloId].actionsForImprovement
                }
                
                if (programAssessmentId) {
                    let stepSloId = getStep4SloDataId({
                        programId: programId, 
                        sloId: slo.sloId,
                        assessment: appData.assessment,
                    })
                    if (stepSloId) {
                        tmpSloData["step4sloDataId"] = stepSloId
                    }
                }

                s4SloData.push(tmpSloData)
            }
        })

        if (s4SloData.length > 0) {
            s4Data["learningOutcomes"] = s4SloData
            
        }
        return s4Data                
    } // --end step 4
    return null
}

const getStep5Id = (appData) => {
    let programAssessment = getCachedProgramAssessment(appData)
    if (programAssessment.step5Data) {
        return programAssessment.step5Data.step5Id
    }
}

const getStep5SloDataId = (appData) => {
    const sloId = appData['sloId']

    let programAssessment = getCachedProgramAssessment(appData)
    if (programAssessment.step5Data) {
        if (programAssessment.step5Data.step5Id) {
            let tmp_step5Data = programAssessment.step5Data
            for (let i = 0; i < tmp_step5Data.learningOutcomes.length; i++) {
                let tmp_sloData = tmp_step5Data.learningOutcomes[i]
                if (tmp_sloData.step5sloDataId &&
                        tmp_sloData.sloId == sloId) {
                    return tmp_sloData.step5sloDataId
                }
            }
        }
    }
}

const formatStep5Data = (appData) => {
    let dateTime = appData['dateTime']
    let programAssessmentId = appData['programAssessmentId']
    let programId = appData['programId']
    let learningOutcomes = appData['learningOutcomes']
    let step5Tab1DataStore = appData['step5Tab1DataStore']
    let step5Tab2DataStore = appData['step5Tab2DataStore']
    let step5CompletionData = appData['step5CompletionData']
    let currentUser = appData['currentUser']

    let step5Tab1Data = step5Tab1DataStore[programId]
    let step5Tab2Data = step5Tab2DataStore[programId]
    let result = null
    if (step5Tab1Data || step5Tab2Data) {
        let s5Data = {
            createdBy: step5CompletionData[programId].createdBy,
            dateCreated: step5CompletionData[programId].dateCreated,
            modifiedBy: currentUser,
            dateModified: dateTime.toISOString()
        }

        if (programAssessmentId) {
            let step5Id = getStep5Id({
                programId: programId,
                assessment: appData.assessment,
            })
            if (step5Id) {
                s5Data["step5Id"] = step5Id
            }
        }

        if (step5CompletionData[programId]?.completed) {
            s5Data["completed"] = step5CompletionData[programId].completed
            s5Data["dateCompleted"] = step5CompletionData[programId].dateCompleted
            s5Data["completedBy"] = step5CompletionData[programId].completedBy
        } else {
            s5Data["completed"] = false
            s5Data["dateCompleted"] = ""
            s5Data["completedBy"] = ""
        }

        let s5SloData = []
        learningOutcomes[programId].map(slo=> {
            let sloData = {}
            if (slo.sloId in step5Tab1Data || slo.sloId in step5Tab2Data) {
                sloData["sloId"] = slo.sloId
            }
            if (slo.sloId in step5Tab1Data) {
                sloData["cycleSecondDataCollection"] = step5Tab1Data[slo.sloId].s5q30
                sloData["changesPlanned"] = step5Tab1Data[slo.sloId].s5q1
                sloData["dataMotivation"] = step5Tab1Data[slo.sloId].s5q2
                sloData["changeHypothesis"] = step5Tab1Data[slo.sloId].s5q3
                sloData["facultyCommunicationAboutChange"] = step5Tab1Data[slo.sloId].s5q15

                if (step5Tab1Data[slo.sloId].s5q4) { 
                    sloData["changeInApproach"] = step5Tab1Data[slo.sloId].s5q4
                }
                if (step5Tab1Data[slo.sloId].s5q5) { 
                    sloData["changesInFaculty"] = step5Tab1Data[slo.sloId].s5q5
                }
                if (step5Tab1Data[slo.sloId].s5q6) { 
                    sloData["approachToolChanges"] = step5Tab1Data[slo.sloId].s5q6
                }
                if (step5Tab1Data[slo.sloId].s5q7) { 
                    sloData["facultyDevelopment"] = step5Tab1Data[slo.sloId].s5q7
                }
                if (step5Tab1Data[slo.sloId].s5q8) { 
                    sloData["courseContentChanges"] = step5Tab1Data[slo.sloId].s5q8
                }
                if (step5Tab1Data[slo.sloId].s5q9) { 
                    sloData["courseSequencePrerequisiteChanges"] = step5Tab1Data[slo.sloId].s5q9
                }
                if (step5Tab1Data[slo.sloId].s5q10) { 
                    sloData["gradingMethodologyChanges"] = step5Tab1Data[slo.sloId].s5q10
                }
                if (step5Tab1Data[slo.sloId].s5q11) { 
                    sloData["assignmentRevisionChanges"] = step5Tab1Data[slo.sloId].s5q11
                }
                if (step5Tab1Data[slo.sloId].s5q12) { 
                    sloData["budgetaryReallocationChanges"] = step5Tab1Data[slo.sloId].s5q12
                }
                if (step5Tab1Data[slo.sloId].s5q13) { 
                    sloData["otherChanges"] = step5Tab1Data[slo.sloId].s5q13
                }
            }
            if (slo.sloId in step5Tab2Data) {
                sloData["secondRoundToolDescription"] = step5Tab2Data[slo.sloId].s5q17
                sloData["secondRoundCoursesAssessed"] = step5Tab2Data[slo.sloId].s5q18
                sloData["brightspaceAutomation"] = step5Tab2Data[slo.sloId].s5q19
                sloData["secondRoundDataCollection"] = step5Tab2Data[slo.sloId].s5q20
            }

            if (programAssessmentId) {
                let stepSloId = getStep5SloDataId({
                    programId: programId, 
                    sloId: slo.sloId,
                    assessment: appData.assessment,
                })
                if (stepSloId) {
                    sloData["step5sloDataId"] = stepSloId
                }
            }

            if ("sloId" in sloData) {
                s5SloData.push(sloData)
            }
        })
        if (s5SloData.length > 0) {
            s5Data["learningOutcomes"] = s5SloData
        }
        result = s5Data
    } // --end of Step 5
    return result
}

// Step 6
const getStep6Id = (appData) => {
    let programAssessment = getCachedProgramAssessment(appData)
    if (programAssessment.step6Data) {
        return programAssessment.step6Data.step6Id
    }
}

const formatStep6Data = (appData) => {
    let dateTime = appData['dateTime']
    let programAssessmentId = appData['programAssessmentId']
    let programId = appData['programId']
    let step6DataStore = appData['step6DataStore']
    let step6CompletionData = appData['step6CompletionData']
    let currentUser = appData['currentUser']

    let step6Data = step6DataStore[programId]
    let result = null
    if (step6Data) {
        let s6Data = {
            secondAssessmentCompleted: step6Data.s6q1,
            createdBy: step6CompletionData[programId].createdBy,
            dateCreated: step6CompletionData[programId].dateCreated,
            modifiedBy: currentUser,
            dateModified: dateTime.toISOString()
        }

        if (step6CompletionData[programId]?.completed) {
            s6Data["completed"] = step6CompletionData[programId].completed
            s6Data["dateCompleted"] = step6CompletionData[programId].dateCompleted
            s6Data["completedBy"] = step6CompletionData[programId].completedBy
        } else {
            s6Data["completed"] = false
            s6Data["dateCompleted"] = ""
            s6Data["completedBy"] = ""
        }

        if (programAssessmentId) {
            let step6Id = getStep6Id({
                programId: programId,
                assessment: appData.assessment,
            })
            if (step6Id) {
                s6Data["step6Id"] = step6Id
            }
        }

        result = s6Data
    } // --end step 6
    return result
}

// Step 7
const getStep7Id = (appData) => {
    let programAssessment = getCachedProgramAssessment(appData)
    if (programAssessment.step7Data) {
        return programAssessment.step7Data.step7Id
    }
}

const getStep7SloDataId = (appData) => {
    const sloId = appData['sloId']
    let programAssessment = getCachedProgramAssessment(appData)
    if (programAssessment.step7Data) {
        if (programAssessment.step7Data.step7Id) {
            let tmp_step7Data = programAssessment.step7Data
            for (let i = 0; i < tmp_step7Data.learningOutcomes.length; i++) {
                let tmp_sloData = tmp_step7Data.learningOutcomes[i]
                if (tmp_sloData.step7sloDataId &&
                        tmp_sloData.sloId == sloId) {
                    return tmp_sloData.step7sloDataId
                }
            }
        }
    }
}

const getStep7Data = (appData) => {
    const programAssessmentId = appData['programAssessmentId']
    const assessment = appData['assessment']

    let programAssessment = assessment.programAssessments.find((a) => a.assessmentId === programAssessmentId)
    if (programAssessment && programAssessment.step7Data) {
        return programAssessment.step7Data
    }
}

const hasFinalReflection = (appData) => {
    const programAssessmentId = appData['programAssessmentId']
    const assessment = appData['assessment']

    let programAssessment = assessment.programAssessments.find((a) => a.assessmentId === programAssessmentId)
    // TODO: Fix this logic: make it more readable
    if (!programAssessment || !programAssessment?.step7Data) {
        return false
    }
    // TODO: Fix this logic: make it more readable
    if (programAssessment?.step7Data?.finalReflection) {
        return true
    }

    return false
}

const formatStep7Data = (appData) => {
    let dateTime = appData['dateTime']
    let programAssessmentId = appData['programAssessmentId']
    let programId = appData['programId']
    let learningOutcomes = appData['learningOutcomes']
    let step7Tab1DataStore = appData['step7Tab1DataStore']
    let step7Tab2DataStore = appData['step7Tab2DataStore']
    let step7CompletionData = appData['step7CompletionData']
    let step7Tab2CompletionData = appData['step7Tab2CompletionData']
    let currentUser = appData['currentUser']

    let result = null
    let step7Tab1Data = step7Tab1DataStore[programId]
    let step7Tab2Data = step7Tab2DataStore[programId]
    if (!(programId in step7Tab1DataStore)) {
        step7Tab1Data = {}
    }
    if (!(programId in step7Tab2DataStore)) {
        step7Tab2Data = {}
    }
    
    if (Object.keys(step7Tab1Data).length > 0 || Object.keys(step7Tab2Data) > 0) {
        let s7Data = {
            createdBy: step7CompletionData[programId].createdBy,
            dateCreated: step7CompletionData[programId].dateCreated,
            modifiedBy: currentUser,
            dateModified: dateTime.toISOString()
        }

        if (programAssessmentId) {
            let step7Id = getStep7Id({
                programId: programId,
                assessment: appData.assessment,
            })
            if (step7Id) {
                s7Data["step7Id"] = step7Id
            }
        }

        let finalReflection = {}
        if ("s7q1" in step7Tab2Data) {
            finalReflection['themeLessonsLearned'] = step7Tab2Data.s7q1
        }
        if ("s7q2" in step7Tab2Data) {
            finalReflection['longTermProgramChanges'] = step7Tab2Data.s7q2
        }
        if ("s7q3" in step7Tab2Data) {
            finalReflection['studentAchievementChanges'] = step7Tab2Data.s7q3
        }
        if ("s7q4" in step7Tab2Data) {
            finalReflection['externalFactors'] = step7Tab2Data.s7q4
        }
        
        //
        // TODO: we need to check if final reflection existed before
        //
        if (Object.keys(finalReflection).length > 0) {
            s7Data['finalReflection'] = finalReflection
            s7Data['finalReflection'].modifiedBy = currentUser
            s7Data['finalReflection'].dateModified = dateTime.toISOString()
            if (hasFinalReflection({
                    programAssessmentId: programAssessmentId,
                    assessment: appData.assessment,
                })) {
                let cachedStep7Data = getStep7Data({
                    programAssessmentId: programAssessmentId,
                    assessment: appData.assessment,
                })
                // Get the createdBy and dateCreated from the cached assessment
                s7Data['finalReflection'].createdBy = cachedStep7Data.finalReflection.createdBy
                s7Data['finalReflection'].dateCreated = cachedStep7Data.finalReflection.dateCreated
            } else {
                s7Data['finalReflection'].createdBy = currentUser
                s7Data['finalReflection'].dateCreated = dateTime.toISOString()
            }
            if (step7Tab2CompletionData[programId].completed) {
                s7Data['finalReflection'].completed = step7Tab2CompletionData[programId].completed
                s7Data['finalReflection'].dateCompleted = step7Tab2CompletionData[programId].dateCompleted
                s7Data['finalReflection'].completedBy = step7Tab2CompletionData[programId].completedBy
            }
        } else {
            console.log('Missing final reflection')
        }

        if (step7CompletionData[programId]?.completed) {
            s7Data["completed"] = step7CompletionData[programId].completed
            s7Data["dateCompleted"] = step7CompletionData[programId].dateCompleted
            s7Data["completedBy"] = step7CompletionData[programId].completedBy
        } else {
            s7Data["completed"] = false
            s7Data["dateCompleted"] = ""
            s7Data["completedBy"] = ""
        }
        
        let s7SloData = []
        learningOutcomes[programId].map(slo=> {
            if (step7Tab1Data && (slo.sloId in step7Tab1Data)) {
                let tmpSloData = {
                    sloId: slo.sloId,
                    summaryOfResults: step7Tab1Data[slo.sloId].s7q1,
                    interpretationOfBothRounds: step7Tab1Data[slo.sloId].s7q2,
                    followUpAndNextSteps: step7Tab1Data[slo.sloId].s7q3
                }

                if (programAssessmentId) {
                    let stepSloId = getStep7SloDataId({
                        programId: programId, 
                        sloId: slo.sloId,
                        assessment: appData.assessment,
                    })
                    if (stepSloId) {
                        tmpSloData["step7sloDataId"] = stepSloId
                    }
                }

                s7SloData.push(tmpSloData)
            }
        })
        if (s7SloData.length > 0) {
            s7Data["learningOutcomes"] = s7SloData
        }
        result = s7Data
    } // --end of Step 7

    return result
}

const getAvailableLearningOutcomes = (params) => {
    let availableLearningOutcomes = {}
    params.department.submittedPrograms.map(program => {
        let programMappedSlos = params.mappedSlos[program.programId]
        
        if (!(program.programId in availableLearningOutcomes)) {
            availableLearningOutcomes[program.programId] = []
        }

        let theme = params.theme
        params.programLearningOutcomes[params.departmentId].learningOutcomes[program.programId].map(slo => {
            let mappedSlo = programMappedSlos[slo.sloId]
            if (mappedSlo.firstTheme === theme.name && mappedSlo.firstThemeAnswer === 'yes') {
                availableLearningOutcomes[program.programId].push(slo)
            } else if (mappedSlo.secondTheme === theme.name && mappedSlo.secondThemeAnswer === 'yes') {
                availableLearningOutcomes[program.programId].push(slo)
            } else if (mappedSlo.thirdTheme === theme.name && mappedSlo.thirdThemeAnswer === 'yes') {
                availableLearningOutcomes[program.programId].push(slo)
            }
        })
    })
    return availableLearningOutcomes
}

export function formatAssessmentPutData(appData) {
    console.log('putAssessment: format PUT data')
    let formattedAssessmentData = []
    let availableLearningOutcomes = getAvailableLearningOutcomes({
        departmentId: appData['departmentId'],
        department: appData['department'],
        mappedSlos: appData['mappedSlos'],
        programLearningOutcomes: appData['programLearningOutcomes'],
        theme: appData['theme'],
    })
    console.log(appData)
    const dt = new Date()
    const departmentId = appData.departmentId
    const deptAssessment = appData.assessment
    const currentUser = appData.currentUser
    const activePrograms = appData.activePrograms


    deptAssessment.programAssessments.forEach((assessment) => {
        let programAssessmentId = getProgramAssessmentId({
            programId: assessment.programId,
            assessment: deptAssessment,
        })
        let programAssessment = {
            programAssessmentId: programAssessmentId,
            departmentId: parseInt(departmentId),
            programId: assessment.programId,
            reviewYear: assessment.reviewYear,
            themeId: assessment.themeId,
            createdBy: assessment.createdBy,
            dateCreated: assessment.dateCreated,
            modifiedBy: currentUser,
            dateModified: dt.toISOString()
        }
        
        let s1Data = formatStep1Data({
            dateTime: dt,
            assessment: deptAssessment,
            programAssessmentId: programAssessmentId,
            programId: assessment.programId,
            learningOutcomes: availableLearningOutcomes,
            step1DataStore: appData['step1DataStore'],
            step1CompletionData: appData['step1CompletionData'],
            currentUser: appData['currentUser'],
        })
        if (s1Data) {
            programAssessment["step1Data"] = s1Data
        }
        let s2Data = formatStep2Data({
            dateTime: dt,
            assessment: deptAssessment,
            programAssessmentId: programAssessmentId,
            programId: assessment.programId,
            learningOutcomes: availableLearningOutcomes,
            step2DataStore: appData['step2DataStore'],
            step2CompletionData: appData['step2CompletionData'],
            currentUser: appData['currentUser'],
        })
        if (s2Data) {
            programAssessment["step2Data"] = s2Data
        }
        let s3Data = formatStep3Data({
            dateTime: dt,
            assessment: deptAssessment,
            programAssessmentId: programAssessmentId,
            programId: assessment.programId,
            step3DataStore: appData['step3DataStore'],
            step3CompletionData: appData['step3CompletionData'],
            currentUser: appData['currentUser'],
        })
        if (s3Data) {
            programAssessment["step3Data"] = s3Data
        }
        let s4Data = formatStep4Data({
            dateTime: dt,
            assessment: deptAssessment,
            programAssessmentId: programAssessmentId,
            programId: assessment.programId,
            learningOutcomes: availableLearningOutcomes,
            step4DataStore: appData['step4DataStore'],
            step4CompletionData: appData['step4CompletionData'],
            currentUser: appData['currentUser'],
        })
        if (s4Data) {
            programAssessment["step4Data"] = s4Data
        }
        let s5Data = formatStep5Data({
            dateTime: dt,
            assessment: deptAssessment,
            programAssessmentId: programAssessmentId,
            programId: assessment.programId,
            learningOutcomes: availableLearningOutcomes,
            step5Tab1DataStore: appData['step5Tab1DataStore'],
            step5Tab2DataStore: appData['step5Tab2DataStore'],
            step5CompletionData: appData['step5CompletionData'],
            currentUser: appData['currentUser'],
        })
        if (s5Data) {
            programAssessment["step5Data"] = s5Data
        }
        let s6Data = formatStep6Data({
            dateTime: dt,
            assessment: deptAssessment,
            programAssessmentId: programAssessmentId,
            programId: assessment.programId,
            step6DataStore: appData['step6DataStore'],
            step6CompletionData: appData['step6CompletionData'],
            currentUser: appData['currentUser'],
        })
        if (s6Data) {
            programAssessment["step6Data"] = s6Data
        }
        let s7Data = formatStep7Data({
            dateTime: dt,
            assessment: deptAssessment,
            programAssessmentId: programAssessmentId,
            programId: assessment.programId,
            learningOutcomes: availableLearningOutcomes,
            step7Tab1DataStore: appData['step7Tab1DataStore'],
            step7Tab2DataStore: appData['step7Tab2DataStore'],
            step7CompletionData: appData['step7CompletionData'],
            step7Tab2CompletionData: appData['step7Tab2CompletionData'],
            currentUser: appData['currentUser'],
        })
        if (s7Data) {
            programAssessment["step7Data"] = s7Data
        }

        formattedAssessmentData.push(programAssessment)
    })

    // Now append any NEW assessments not previously saved.
    // These can be found by finding subset of active programs
    // selected, but not previously saved.
    Object.keys(activePrograms).forEach((programId) => {
        let existingAssessment = deptAssessment.programAssessments.find((programAssessment) => programAssessment.programId == programId)
        if (!existingAssessment) {
            // Format the program assessment and add to formattedAssessmentData
            let programAssessment = {
                departmentId: parseInt(departmentId),
                programId: parseInt(programId),
                reviewYear: deptAssessment.reviewYear,
                themeId: deptAssessment.themeId,
                createdBy: currentUser,
                dateCreated: dt.toISOString(),
                modifiedBy: currentUser,
                dateModified: dt.toISOString()
            }

            let s1Data = formatStep1Data({
                step1DataStore: appData['step1DataStore'],
                step1CompletionData: appData['step1CompletionData'],
                currentUser: appData['currentUser'],
                dateTime: dt,
                programAssessmentId: appData['programAssessmentId'],
                programId: programId,
                learningOutcomes: availableLearningOutcomes,
            })
            if (s1Data) {
                programAssessment["step1Data"] = s1Data
            }
            let s2Data = formatStep2Data({
                step2DataStore: appData['step2DataStore'],
                step2CompletionData: appData['step2CompletionData'],
                currentUser: appData['currentUser'],
                dateTime: dt,
                programAssessmentId: appData['programAssessmentId'],
                programId: programId,
                learningOutcomes: availableLearningOutcomes,
            })
            if (s2Data) {
                programAssessment["step2Data"] = s2Data
            }
            let s3Data = formatStep3Data({
                step3DataStore: appData['step3DataStore'],
                step3CompletionData: appData['step3CompletionData'],
                currentUser: appData['currentUser'],
                dateTime: dt,
                programAssessmentId: appData['programAssessmentId'],
                programId: programId,
                learningOutcomes: availableLearningOutcomes,
            })
            if (s3Data) {
                programAssessment["step3Data"] = s3Data
            }
            let s4Data = formatStep4Data({
                step4DataStore: appData['step4DataStore'],
                step4CompletionData: appData['step4CompletionData'],
                currentUser: appData['currentUser'],
                dateTime: dt,
                programAssessmentId: appData['programAssessmentId'],
                programId: programId,
                learningOutcomes: availableLearningOutcomes,
            })
            if (s4Data) {
                programAssessment["step4Data"] = s4Data
            }
            let s5Data = formatStep5Data({
                step5Tab1DataStore: appData['step5Tab1DataStore'],
                step5Tab2DataStore: appData['step5Tab2DataStore'],
                step5CompletionData: appData['step5CompletionData'],
                currentUser: appData['currentUser'],
                dateTime: dt,
                programAssessmentId: appData['programAssessmentId'],
                programId: programId,
                learningOutcomes: availableLearningOutcomes,
            })
            if (s5Data) {
                programAssessment["step5Data"] = s5Data
            }
            let s6Data = formatStep6Data({
                step6DataStore: appData['step6DataStore'],
                step6CompletionData: appData['step6CompletionData'],
                currentUser: appData['currentUser'],
                dateTime: dt,
                programAssessmentId: appData['programAssessmentId'],
                programId: programId,
                learningOutcomes: availableLearningOutcomes,
            })
            if (s6Data) {
                programAssessment["step6Data"] = s6Data
            }
            let s7Data = formatStep7Data({
                step7Tab1DataStore: appData['step7Tab1DataStore'],
                step7Tab2DataStore: appData['step7Tab2DataStore'],
                step7CompletionData: appData['step7CompletionData'],
                step7Tab2CompletionData: appData['step7Tab2CompletionData'],
                currentUser: appData['currentUser'],
                dateTime: dt,
                programAssessmentId: appData['programAssessmentId'],
                programId: programId,
                learningOutcomes: availableLearningOutcomes,
            })
            if (s7Data) {
                programAssessment["step7Data"] = s7Data
            }

            formattedAssessmentData.push(programAssessment)
        }
    })

    return formattedAssessmentData
}